import { RegistryService } from './registry/registry.service';
import { AnalyticsService } from './analytics/analytics.service';
import { environment } from './../environments/environment';
import { AuthService, User } from './user/auth.service';
import { RegistryFirebaseService } from './registry/registry-firebase.service';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { Component, ViewEncapsulation, OnInit, HostListener } from '@angular/core';
import { AppRouterState } from './app.router.state';
import { Intercom } from 'ng-intercom';

@Component({

  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AppComponent implements OnInit {

  private scripts: any = {};
showCreateGiftHelp = false;
appMode = ''
  registryName: string;
  // this.todo$ = this.firestoreService.col$<Todo>('todos');
  isLoggedIn = false;
  step = 1;
  currentUrl :string;
  guestMode = false;

  constructor(

    private intercom: Intercom,
    private appRouterState: AppRouterState,
    private _analyticsService: AnalyticsService,
    private _registryService: RegistryService,
    private router: Router

  ) {
;
    if ((<any>window).app_mode){
      this.appMode = (<any>window).app_mode;


    } 

    if(location.pathname.toLowerCase() === '/registry'){
      this.appMode = 'registry';
    }
    
    if ((<any>window).guest_mode){
      this.guestMode = true;


    }
    this.isEu().then(isEu => {

    });

    this.router.events.subscribe(val => {
      
      if (val instanceof NavigationEnd) {
        (<any>window).analytics.page({
          path: val.url,
          title: document.title,
          url: document.URL,

        });
        
      }
    });

    this.router.events.subscribe((event) => {
      if (!(this.router.url.indexOf('/registry/create-gift') > -1)) {
        this.showCreateGiftHelp = false;
        const body = document.getElementsByTagName('body')[0];
        body.style.overflow = 'auto';

      } else {


      }

    });

    // NavigationEnd
    // NavigationCancel
    // NavigationError
    // RoutesRecognized
    // });
    //   if ( (<any>window).analytics != undefined){
    //   (<any>window).analytics.page()
    //   }
    // });

    // this.intercom.boot(myIntercomConfig)
    this.appRouterState.params.subscribe(params => {

      //
      if (params) {
        this.registryName = params;
      }
    });


  }


  getIntergrations(): Promise<any> {
    let stats = false;
    let marketing = false;

    const concent1: Promise<any> =
      new Promise(
        (resolve, reject) => {

          (<any>window).Metomic('getConsentState', { slug: 'statistics' }, ({ enabled }) => {
            stats = enabled;
            resolve(enabled);
          });
        });
    const concent2: Promise<any> =

      new Promise(
        (resolve, reject) => {

          (<any>window).Metomic('getConsentState', { slug: 'marketing' }, ({ enabled }) => {
            marketing = enabled;
            resolve(enabled);
          });
        });
   return Promise.all([concent1, concent2]).then(() => {

      return {
        All: false,
        'Google Analytics': true,
        'Segment.io': true,
        'Facebook Pixel': marketing,
        Heap: stats,
        Intercom: true,
        FullStory: true
      };
    });



  }
  loadScript(name: string) {
    return new Promise((resolve, reject) => {
      const script: any = document.createElement('script');
      script.type = 'text/javascript';
      script.src = name;
      if (script.readyState) {  // IE
        script.onreadystatechange = () => {

          if (script.readyState === 'loaded' || script.readyState === 'complete') {
            script.onreadystatechange = null;
            // this.scripts[name].loaded = true;
            resolve({ script: name, loaded: true, status: 'Loaded' });
          }
        };
      }
      script.onerror = (error: any) => resolve({ script: name, loaded: false, status: 'Loaded' });
      document.getElementsByTagName('head')[0].appendChild(script);

    });
  }

  isEu(): Promise<boolean> {
    const iseu = localStorage.getItem('is_eu');
    return new Promise(
      (resolve, reject) => {

        if (iseu == null || iseu === undefined) {
          const http = new XMLHttpRequest();
          http.open(
            'GET',
            'https://api.ipdata.co/?api-key=0aca3a36be4c02047be573615c60b4955a648594bde67ca7da76a83f'
          );
          http.send();
          http.onload = () => {
            const result = JSON.parse(http.responseText);
            localStorage.setItem('is_eu', result.is_eu);

            resolve(result.is_eu as boolean);
          };
        } else {
          resolve(iseu === 'true');
        }
      });
  }

  loadSegment(concentedIntergrations: Promise<any>) {

    let segmentId = 'XdGAVQOJa4tqOO5yuRDElH4Vl1Oe9GNT';

    if (window.location.host === 'www.hitchd.com'){
      segmentId = 'Qa3RTTPht0LsCz64ikyPdxeXI6R0kPcK';
    }

    if (!concentedIntergrations) {

      (<any>window).analytics.load(segmentId);
   //   (<any>window).analytics.page();
    }
    else {
      concentedIntergrations.then(concent => {
        (<any>window).analytics.load(segmentId, {
          integrations: concent
        });
      //  (<any>window).analytics.page();

      });


    }


  }

  closePopup(){

    this.showCreateGiftHelp = false;
    const body = document.getElementsByTagName('body')[0];
    body.style.overflow = 'auto';
    localStorage.setItem('seen_create_help_modal', '1');
  }

  ngOnInit(): void {
//     if (location.pathname.toLowerCase() === '/registry') {
// this.router.navigate(['/overview']);
//     }
//console.log(`app component loaded`);



if(localStorage.getItem('registry-lang-selected')){
  
  localStorage.removeItem('registry-lang-selected');
}
this.currentUrl = location.pathname;
this._registryService.showCreateHelpPopup$.subscribe(() => {
this.showCreateGiftHelp = true;
const body = document.getElementsByTagName('body')[0];
body.style.overflow = 'hidden';
this.step = 1;
});


if (
  window.navigator.platform !== "MacIntel" &&
  window.navigator.userAgent.indexOf("iPhone") === -1 &&
  window.navigator.userAgent.indexOf("iPad") === -1 &&
  window.navigator.userAgent.indexOf("iPod") === -1 &&
  window.navigator.userAgent.indexOf("Macintosh") === -1
) {
  // Not an Apple device
  const body = document.getElementsByTagName('body')[0];
  body.classList.add('non-mac') 
} else {
  const body = document.getElementsByTagName('body')[0];
  body.classList.add('mac') 
}

  }
}



// <script>
//
//   var initCookies = false;
//   Metomic('ConsentManager:onShow', () => {
//     // ConsentManager is visible
//     if (!initCookies){
//       Metomic('ConsentManager:hide')
//       initCookies = true;
//     }
//   })


//   window.onload = function() {
//     function loadAnalytics(isEu) {
//       if ((isEu == "true" || isEu == true) && setBefore != "true") {
//         var consent = setIntergrations();
//         analytics.load("XdGAVQOJa4tqOO5yuRDElH4Vl1Oe9GNT", {
//           integrations: consent
//         });
//         analytics.page();
//       } else {
//         analytics.load("XdGAVQOJa4tqOO5yuRDElH4Vl1Oe9GNT", {
//           integrations: {
//             All: false,
//             "Google Analytics": true,
//             "Segment.io": true,
//             "Facebook Pixel": true,
//             Heap: true,
//             Intercom: true
//           }
//         });
//         analytics.page();
//       }

//     var iseu = localStorage.getItem("is_eu");

//     if (iseu == null || iseu == undefined) {
//       const http = new XMLHttpRequest();
//       http.open(
//         "GET",
//         "https://api.ipdata.co/?api-key=0aca3a36be4c02047be573615c60b4955a648594bde67ca7da76a83f"
//       );
//       http.send();
//       http.onload = () => {
//         var result = this.JSON.parse(http.responseText);
//         localStorage.setItem("is_eu", result.is_eu);
//         loadAnalytics(result.is_eu);
//       };
//     } else {
//       loadAnalytics(iseu);
//     }
//   };

// </script>



// WEBPACK FOOTER //
// ./src/app/app.component.ts